import React from "react";
import {  MDBRow, MDBContainer } from "mdbreact";


const Strategy = () => {
    return (
        <MDBContainer id="strategy" className="text-center my-5">
            <h2 className="h1-responsive font-weight-bold my-5">
                Strategy
            </h2>
            <p className="lead black-text w-responsive mx-auto mb-5">
                We offer advisory services on Web and Mobile technologies and 
                how you can make the most of them for your Product or Business. 
                From Product and User Interface Design through to technology 
                and platform selection, we will work with you to choose the 
                best possible path.
            </p>
        </MDBContainer>
    );
}

export default Strategy;